import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['days', 'label', 'indicator'];
  static classes = ['hidden', 'empty'];
  static values = {
    lengthInDays: String,
    startDate: String,
    endDate: String,
  };

  #isWithinDateRange() {
    return !this.#hasEnded() && !this.#hasNotStarted();
  }

  #updateLabel(text) {
    this.labelTarget.textContent = text;
    // this.labelTarget.classList.remove(this.hiddenClass);
  }

  #getLabelTextForStatus() {
    return this.#hasEnded() ? 'Ended' : 'Hasn’t started yet';
  }

  #updateIndicator(percentage) {
    let styleRight = percentage > 5 ? `calc(${percentage}% - 2px)` : `${percentage}%`;
    // this.indicatorTarget.style.right = styleRight;
    this.indicatorTarget.style.width = styleRight;
    // this.indicatorTarget.classList.remove(this.hiddenClass);
  }

  #getIndicatorPercentage() {
    return (this.#getDaysSinceStart() / this.lengthInDaysValue) * 100;
  }

  #getDaysSinceStart() {
    const millisecondsPerDay = 86400 * 1000; // 24 hours * 60 minutes * 60 seconds * 1000 milliseconds
    return Math.ceil((this.#getCurrentDateInMilliseconds() - this.#getStartDateInMilliseconds()) / millisecondsPerDay);
  }

  #hasEnded() {
    return this.#getEndDateInMilliseconds() < this.#getCurrentDateInMilliseconds();
  }

  #hasNotStarted() {
    return this.#getStartDateInMilliseconds() > this.#getCurrentDateInMilliseconds();
  }

  #getCurrentDateInMilliseconds() {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to start of the day
    return today.getTime();
  }

  #getStartDateInMilliseconds() {
    const startDate = new Date(this.startDateValue);
    startDate.setHours(0, 0, 0, 0); // Set to start of the day
    return startDate.getTime();
  }

  #getEndDateInMilliseconds() {
    const endDate = new Date(this.endDateValue);
    endDate.setHours(0, 0, 0, 0); // Set to start of the day
    return endDate.getTime();
  }

  connect() {
    if (this.#isWithinDateRange()) {
      this.#updateIndicator(this.#getIndicatorPercentage());
    } else {
      this.element.classList.add(this.emptyClass);
      this.#updateLabel(this.#getLabelTextForStatus());
    }
  }
}
